import React from 'react';
import { Stack, Button } from '@mui/material';
import {
  OpenInNew as NavigateIcon,
  Article as ArticleIcon,
  PlayArrow as ActionIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useHelpContext } from '../../contexts/HelpWidgetContext';
import type { SuggestedAction } from '../../types/help.types';

interface SuggestedActionsProps {
  actions: SuggestedAction[];
}

const actionIcons = {
  navigate: <NavigateIcon fontSize="small" />,
  article: <ArticleIcon fontSize="small" />,
  action: <ActionIcon fontSize="small" />,
};

export const SuggestedActions: React.FC<SuggestedActionsProps> = ({ actions }) => {
  const navigate = useNavigate();
  const { selectArticle, closeHelp } = useHelpContext();

  const handleActionClick = (action: SuggestedAction) => {
    switch (action.type) {
      case 'navigate':
        closeHelp();
        navigate(action.target);
        break;

      case 'article':
        selectArticle(action.target);
        break;

      case 'action':
        // Handle custom actions
        console.log('Custom action:', action.target);
        break;
    }
  };

  if (!actions || actions.length === 0) {
    return null;
  }

  return (
    <Stack direction="row" spacing={1} flexWrap="wrap" gap={0.5}>
      {actions.map((action, index) => (
        <Button
          key={`${action.type}-${action.target}-${index}`}
          variant="outlined"
          size="small"
          startIcon={actionIcons[action.type]}
          onClick={() => handleActionClick(action)}
          sx={{
            borderRadius: 2,
            textTransform: 'none',
            fontSize: '0.75rem',
          }}
        >
          {action.label}
        </Button>
      ))}
    </Stack>
  );
};

export default SuggestedActions;
